import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';

import { DestinationsState } from '@/states';
import { ReportsContainer } from '@/providers';
import { ConnectionQuery } from '@/queries/connection';
import { useSession } from '@/states/common';
import type { ActivationState } from '@/states/home/states';

export const useComputedActivationState = () => {
  const { data } = useSession();
  const destination = useRecoilValue(DestinationsState);
  const { state: reportState } = ReportsContainer.useContainer();

  const { data: providerAccounts } = ConnectionQuery.useDataSources(
    data.business?.id || ''
  );

  const computeState = useCallback((): ActivationState => {
    // Account is always completed if user is logged in
    const accountStatus = 'completed' as const;

    // Check datasources - filter connected accounts (those with clientId)
    const connectedAccounts =
      providerAccounts?.filter?.((acc: any) => acc?.clientId) ?? [];
    const datasourcesStatus =
      connectedAccounts.length > 0
        ? ('completed' as const)
        : ('pending' as const);

    // Check destinations - check if destination object has any keys
    const hasDestination = Object.keys(destination).length > 0;
    const destinationStatus = hasDestination
      ? ('completed' as const)
      : ('pending' as const);

    // Check reports
    const hasReports = reportState.reports.length > 0;
    const reportStatus = hasReports
      ? ('completed' as const)
      : ('pending' as const);

    return {
      account: accountStatus,
      datasources: datasourcesStatus,
      destination: destinationStatus,
      report: reportStatus,
    };
  }, [providerAccounts, destination, reportState.reports.length]);

  return { computeState };
};
